import styled from 'styled-components';
import typography from '../../theme/typography';
import {StyledCounterProps} from './typings';
import zIndex from '../../theme/constants/zIndex';

export const StyledErrorMsg = styled.h2`
  ${typography.Highlights}
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCounter = styled.div<StyledCounterProps>`
  p {
    ${typography.Body2}
    height: 40px;
    line-height: 33px;
    padding-left: 10px;
  }

  ${(props) =>
    props.$shift &&
    `
  position: relative;
  height: 0;

  p{
    height: 60px;
    line-height: 60px;
    position: absolute;
    top: -60px;
    left: 0;
    z-index: calc(${zIndex.sticky} + 1); // Make it slightly higher than sticky filters
  }
  `}
`;
